import { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import { UserState } from '../../../reducers/user';
import { useDynamicFormContext } from '../context';
import { FieldProps } from '../types';

const useStyles = makeStyles(() => ({
  textarea: {
    width: '100%',
  },
  answer: {
    margin: 0,
    whiteSpace: 'pre-line',
  },
}));

function TextField(props: FieldProps) {
  const { field, answer } = props.filledOutField;

  const classes = useStyles();
  const { roleView } = useSelector((selector: { user: UserState }) => ({
    roleView: selector.user.roleView,
  }));

  const { setAnswerValues, formIsReadOnly } = useDynamicFormContext();

  const [inputValue, setInputValue] = useState<string>(answer?.value || '');

  if (roleView === null) {
    throw new Error('Invalid session');
  }

  if (field.discr !== 'textfield') {
    throw new Error('Unsupported field');
  }

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(event.target.value);
  };

  useEffect(() => {
    setAnswerValues((prev) => ({
      ...prev,
      [String(field.id)]: inputValue,
    }));
  }, [setAnswerValues, field.id, inputValue]);

  if (formIsReadOnly || props.filledOutField.field.readOnly) {
    return (
      <p className={classes.answer}>
        {answer?.value ? answer.value : 'Onbekend'}
      </p>
    );
  }

  return (
    <textarea
      rows={4}
      className={classes.textarea}
      defaultValue={answer?.value || ''}
      onChange={handleChange}
    />
  );
}

export default TextField;
